// src/pages/ApplyNow.jsx
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { postRequest } from "../../apis/ApiInstence";

const ApplyNow = () => {
  const location = useLocation();
  const jobTitle = location.state?.job_title || localStorage.getItem("job_title") || "";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    resume: null,
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!jobTitle) {
      setError("❌ Job title missing. Please try again from job detail page.");
      return;
    }

    const data = new FormData();
    data.append("job_title", jobTitle);
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("mobile", formData.mobile);
    if (formData.resume) {
      data.append("resume", formData.resume);
    }

    try {
      await postRequest("applynow", data);
      setMessage("✅ Application submitted successfully.");
      setError("");
      setFormData({ name: "", email: "", mobile: "", resume: null });
    } catch (err) {
      console.error("Form submission error:", err);
      setError("❌ Submission failed. Please check your input and try again.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center px-4 py-10">
      <h1 className="text-3xl font-bold mb-4 text-[#345bf3]">Apply Now</h1>

      <div className="max-w-lg w-full bg-white p-6 shadow-lg rounded">
        {jobTitle && (
          <p className="text-md font-medium mb-3 text-gray-700">
            Applying for: <span className="text-black">{jobTitle}</span>
          </p>
        )}

        {message && <p className="mb-4 text-center text-green-600">{message}</p>}
        {error && <p className="mb-4 text-center text-red-600">{error}</p>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            required
          />

          <input
            type="tel"
            name="mobile"
            placeholder="Mobile Number"
            value={formData.mobile}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            required
          />

          <input
            type="file"
            name="resume"
            onChange={handleChange}
            className="w-full border p-2 rounded"
            accept=".pdf,.doc,.docx"
          />

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default ApplyNow;
